<template>
    <div class="mb-3 row">
      <label :for="item.id" class="col-sm-2 col-form-label">{{ item.name }}</label>
      <div class="col-sm-2">
        <select :id="item.id" :name="item.id" class="form-select" @change="handleChange" :disabled="!item.isVisible" v-model="selectedOption">
            <option v-for="option in item.options" :key="option.value" :value="option.value">
            {{ option.name }}
            </option>
        </select>
      </div>
    </div>
  </template>
  
  <script>
  import { defineComponent, ref, watch } from 'vue';
  
  export default defineComponent({
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    emits: ['updateValue'],
    setup(props, { emit }) {
      const selectedOption = ref(props.item.value ?? (props.item.options.length > 0 ? props.item.options[0].value : ''));
      console.log("selectoption ", selectedOption.value)
      emit('updateValue', { id: props.item.id, value:  selectedOption.value});

      
      watch(
        () => props.item.value,
        (newValue) => {
          selectedOption.value = newValue ?? '';
          console.log("selectoption updated to ", selectedOption.value);
        }
      );
      

      const handleChange = (event) => {
        const newValue = event.target.value;
        emit('updateValue', { id: props.item.id, value: newValue });
      };

      return {
        handleChange,
        selectedOption
      };
    }
  });
  </script>